import store from "../index.js";
import router from "../../router/index";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _report: {
    detail: [],
    order_seq: "",
    seq: "",
    phone: "",
    main_seq: "",
  },
  _items: {
    order: [],
    order_init: false,
    detail: [],
    report: {},
    previous_report: {},
    user: [],
    report_share: {},
    realtor_info: {},
    report_realtor_share: {},
    report_gurantee: false,
    act_score: 0,
    previous_act_score: 0,
  },
  _question: {
    kimdongmin: "",
  },
  _realtor_contract: {
    address_gu: "",
    realtor_count: 0,
    report_count: 0,
    contract_count: 0,
  },
  _loan_seo: {
    type: null,
    deposit: null,
  },
  _order_user_report_yn: [],
  _loan_estimated_price: null, // 대출 계산에서 사용자가 변경한 주택가격
  _loan_calc_conditions: {
    houseCondition: "무주택",
    repaymentMethod: "원리금균등",
    loanPeriod: "10",
    interestRate: "3.5",
    loanEok: 0,
    myEok: 0,
    monthlyPayment: 0,
  },
  _loan_region_info: {
    regionType: "",
    totalLimit: 0,
    ltvRate: 0,
  },
};

export const mutations = {
  setReportReset(state) {
    state._report.detail = [];
    state._items.order = [];
    state._items.detail = [];
    state._items.report = [];
    state._items.user = [];
  },
  setReportList(state, response) {
    state._items.report = response;
  },
  setReportDetail(state, response) {
    state._report.detail = [];
    state._report.detail = response.value.data;
  },
  setReportDetailReset(state) {
    state._report.detail = [];
  },
  setOrderDetail(state, item) {
    state._items.detail = [];
    state._items.detail = Object.assign({}, item);
  },
  setOrderDetailReset(state) {
    state._items.detail = [];
  },
  setReport(state, item) {
    state._report.detail = [];
    state._report.detail = Object.assign([], item);
  },
  setOrderUserList(state, item) {
    state._items.order = [];
    state._items.order = Object.assign([], item);
    state._items.order_init = true;
  },
  setReportPre(state, item) {
    state._items.report = item;
  },
  setPreviousReportPre(state, item) {
    state._items.previous_report = item;
  },
  setOrderConfirmDetail(state, item) {
    state._items.detail = [];
    state._items.detail = Object.assign([], item);
  },
  setOrderDetailAssign(state, index) {
    state._items.detail = [];
    state._items.detail.push(Object.assign({}, state._items.order[index]));
  },
  setShareInfo(state, item) {
    state._report.order_seq = item.order_seq;
    state._report.seq = item.seq;
  },
  setSharePhone(state, item) {
    state._report.phone = item;
  },
  setShareMainseq(state, item) {
    state._report.main_seq = item;
  },
  setRealtorInfo(state, item) {
    state._items.realtor_info = item;
  },
  setReportRealtorShare(state, item) {
    state._items.report_realtor_share = item;
  },
  setKimdongminQuestionSeq(state, item) {
    state._question.kimdongmin = item;
  },
  setReportGurantee(state, item) {
    state._items.report_gurantee = item;
  },
  setActScore(state, item) {
    state._items.act_score = item;
  },
  setPreviousActScore(state, item) {
    state._items.previous_act_score = item;
  },
  setRealtorContract(state, items) {
    state._realtor_contract.address_gu = items.address_gu;
    state._realtor_contract.realtor_count = items.realtor_count;
    state._realtor_contract.report_count = items.report_count;
    state._realtor_contract.contract_count = items.contract_count;
  },
  setLoanSeo(state, item) {
    state._loan_seo.type = item.type;
    state._loan_seo.deposit = item.deposit;
  },
  setOwnerHouseProperty(state, item) {
    state._items.report.ownerHouseProperties = item;
  },
  setOrderUserReportYn(state, item) {
    state._order_user_report_yn = [];
    state._order_user_report_yn = item;
  },
  setLoanEstimatedPrice(state, price) {
    state._loan_estimated_price = price;
  },
  setLoanCalcConditions(state, conditions) {
    state._loan_calc_conditions = { ...state._loan_calc_conditions, ...conditions };
  },
  setLoanRegionInfo(state, info) {
    state._loan_region_info = { ...state._loan_region_info, ...info };
  },
};

export const actions = {
  async acReportReset({ commit }) {
    commit("setReportReset");
  },
  acShareInfo({ commit }, item) {
    console.log("itemsss", item);
    commit("setShareInfo", item);
  },
  acSharePhone({ commit }, item) {
    console.log("itemsss", item);
    commit("setSharePhone", item);
  },
  acShareMainseq({ commit }, item) {
    commit("setShareMainseq", item);
  },
  acOrderDetailAssign({ commit }, index) {
    commit("setOrderDetailAssign", index);
  },
  acKimdongminQuestionSeq({ commit }, item) {
    commit("setKimdongminQuestionSeq", item);
  },
  acActScore({ commit }, item) {
    commit("setActScore", item);
  },
  acPreviousActScore({ commit }, item) {
    commit("setPreviousActScore", item);
  },
  acRealtorContract({ commit }, items) {
    commit("setRealtorContract", items);
  },
  async acReportDetail({ commit }, params) {
    const url = `/api/v1/report`;
    try {
      const response = await api.get(url, { params: params });
      commit("setReportDetail", { value: response.data });
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        router.push("/");
      }
      commit("setReportDetailReset");
      return error.response.status;
    }
  },
  async acReportList({ commit }) {
    try {
      const url = `/api/v1/report/users`;
      const res = await api.get(url);
      commit("setReportList", res.data.data);
      return res.data;
    } catch (error) {
      console.log("acReportList error message", error.message);
      return null;
    }
  },
  async acOrderUserList({ commit }) {
    try {
      const url = `/api/v1/order-users`;
      const res = await api.get(url);
      // window.console.log("acOrderUserList res", res);
      commit("setOrderUserList", res.data.data.items);
      return res.data;
    } catch (error) {
      console.log("acOrderUserList error message", error.message);
      return null;
    }
  },
  async acOrderUserReportYnList({ commit }) {
    try {
      const url = `/api/v1/order-users/report`;
      const res = await api.get(url);
      if (res.data?.code === 0) {
        commit("setOrderUserReportYn", res.data.data);
      }
      return res.data?.code === 0;
    } catch (error) {
      console.log("acOrderUserReportYnList error message", error.message);
      ``;
      return false;
    }
  },

  async acReport({ commit }, report_seq) {
    try {
      const url = `/api/v1/report?document=${report_seq}`;
      const res = await api.get(url);
      commit("setReport", res.data.data[0]);
      return res.data.data;
    } catch (error) {
      console.log("acCallGet error message", error.message);
      return null;
    }
  },
  async acReportCart({ commit }, document) {
    try {
      const url = `/api/v1/report/${document}`;
      const res = await api.get(url);
      commit("setReport", res.data.data);
      return res.data.data[0];
    } catch (error) {
      console.log("acCallGet error message", error.message);
      return null;
    }
  },
  async acOrderDetail({ commit }, order_seq) {
    try {
      const url = `/api/v1/order-carts?scan=${encodeURIComponent(order_seq)}`;
      const res = await api.get(url);
      commit("setOrderDetail", res.data?.data);
      return res.data?.code === 0 ? true : false;
    } catch (error) {
      console.log("acCallGet error message", error.message);
      commit("setOrderDetailReset");
      return null;
    }
  },
  async acOrderDetailShare({ commit }, order_seq) {
    try {
      const url = `/api/v1/order-cart-shares/${order_seq}`;
      const res = await api.get(url);
      commit("setOrderDetail", res.data?.data);
      return res.data?.data;
    } catch (error) {
      return null;
    }
  },
  async acReportPre({ commit }, document, realtor_status) {
    try {
      const url = `/api/v1/report/user/${document}?realtor=${realtor_status ? true : false}`;
      const res = await api.get(url);
      if (res?.data?.data?.reportSeq) {
        commit("setReportPre", res.data.data);
      }
      return res.data.data;
    } catch (error) {
      console.log("acReportPre error message", error.message);
      return null;
    }
  },
  async acReportUpgradeInfo({ commit }, document) {
    try {
      const url = `/api/v1/report/user/${document}/upgrade-info`;
      const res = await api.get(url);
      return res.data.data;
    } catch (error) {
      console.log("acReportUpgradeInfo error message", error.message);
      return null;
    }
  },
  async acPreviousReportPre({ commit }, document, realtor_status) {
    try {
      const url = `/api/v1/report/user/${document}/previous?realtor=${
        realtor_status ? true : false
      }`;
      const res = await api.get(url);
      commit("setPreviousReportPre", res.data.data);
      return res.data.data;
    } catch (error) {
      console.log("acPreviousReportPre error message", error.message);
      return null;
    }
  },
  async acReportSharePre({ commit }, cart_seq, realtor_status) {
    try {
      const res = await api.get(
        `/api/v1/report/user/cart/share?document=${cart_seq}&realtor=${
          realtor_status ? true : false
        }`,
      );
      commit("setReportPre", res.data.data);
      return res.data.data[0];
    } catch (error) {
      console.log("setReportSharePre error message", error.message);
      return null;
    }
  },
  async acOrderConfirmDetail({ commit }, order_seq) {
    try {
      const res = await api.get(`/api/v1/order/admin/${order_seq}`);
      commit("setOrderConfirmDetail", res.data.data);
      return res;
    } catch (error) {
      console.log("acOrderConfirmDetail error message", error.message);
      return null;
    }
  },
  async acReportRealtorShare({ commit }, params) {
    const url = `/api/v1/report-realtor/share`;
    try {
      const res = await api.post(url, { ...params });
      return res.data;
    } catch (error) {
      return null;
    }
  },
  async acUpdateReportRealtorShare({ commit }, params) {
    const url = `/api/v1/report-realtor/share`;
    try {
      const res = await api.patch(url, { ...params });
      return res?.data;
    } catch (error) {
      return null;
    }
  },
  async acGetReportRealtorShareList({ commit }) {
    const url = `/api/v1/report-realtor/shares`;
    try {
      const res = await api.get(url);
      const final_data = {};

      for (const data of res.data.data) {
        if (!Object.keys(final_data).length) {
          final_data[data.name] = [{ ...data }];
        } else if (final_data[data.name].length) {
          final_data[data.name].push({ ...data });
        } else {
          final_data[data.name][{ ...data }];
        }
      }

      commit("setReportRealtorShare", final_data);
      return res.data;
    } catch (error) {
      return null;
    }
  },
  async acRealtorInfo({ commit }, params) {
    const url = `/api/v1/report-realtor/reatlor/info?order_seq=${encodeURIComponent(
      params?.order_seq,
    )}`;
    try {
      const res = await api.get(url);
      return res?.data?.data;
    } catch (error) {
      return null;
    }
  },
  async acKimdongminQuestion({}, params) {
    // NZSC-3632: seq가 비면 /kimdongmin/ 로 요청이 나가 404가 된다. 여기서도 fail closed.
    if (params?.seq === null || params?.seq === undefined || params?.seq === "") {
      return false;
    }
    try {
      const url = `/api/v1/report-question/kimdongmin/${params.seq}`;
      const res = await api.post(url, { email: params.email, content: params.content });
      return res.data;
    } catch (err) {
      return false;
    }
  },
  async acUpdateReportNote({ commit }, params) {
    const url = `/api/v1/report-note`;
    try {
      const res = await api.patch(url, { ...params });
      return res?.data?.data;
    } catch (error) {
      return null;
    }
  },

  async acOrderGuarantee({ commit }, params) {
    const url = `/api/v1/report-guarantee`;
    try {
      const res = await api.post(url, { ...params });
      return res?.data;
    } catch (error) {
      return null;
    }
  },

  async acOrderReportGuarantee({ commit }, params) {
    const url = `/api/v1/report-guarantee?cart_seq=${params.cart_seq}`;
    try {
      const res = await api.get(url);
      if (res?.data?.data.guaranteeYn) {
        commit("setReportGurantee", true);
      } else {
        commit("setReportGurantee", false);
      }
      return true;
    } catch (error) {
      return null;
    }
  },
  acAdminReportPreview({ commit }, item) {
    const report = Object.assign({}, item);
    const cart = Object.assign({}, item);
    commit("setOrderDetail", cart.cart);
    delete report.cart;
    commit("setReportPre", report);
  },
  async acUpdateReportRequestData({ commit }, params) {
    const url = `/api/v1/report/user/${params.report_seq}`;
    try {
      const res = await api.patch(url, { ...params });
      return res?.data;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        console.log(commit);
      } else {
        return false;
      }
    }
  },
  async acBeforePaymentReportSimpleList({ commit }, params) {
    const url = `/api/v1/report/simple/before-payment`;
    try {
      const res = await api.get(url, params);
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
      }
      return error.response.status;
    }
  },
  async acHasBuyContractSimpleReport({ commit }, params) {
    const url = `/api/v1/report/simple/has-buy-contract`;
    try {
      const res = await api.get(url, params);
      return res.data?.data?.hasBuyContract || false;
    } catch (error) {
      return false;
    }
  },
  async acUpdateReportFirstDeposit({ commit }, params) {
    const url = `/api/v1/report/user/${params.report_seq}/first-deposit`;
    try {
      const res = await api.patch(url, { ...params });
      return res?.data;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        console.log(commit);
      } else {
        return false;
      }
    }
  },
  // NZSC-3221: 근저당 말소 특약 여부 저장 (전월세 발급완료 플로우 — 계약기간~전월세대출 사이)
  // body: { collateral_cancel_status: 'NONE' | 'WILL' | 'UNKNOWN' }
  // 반환: 성공 시 res.data(truthy), 401·기타 실패 시 false — 호출부가 실패를 인지해 사용자에게 알릴 수 있게 함
  async acUpdateReportCollateralCancel({}, params) {
    const url = `/api/v1/report/user/${params.report_seq}/collateral-cancel`;
    try {
      const res = await api.patch(url, {
        collateral_cancel_status: params.collateral_cancel_status,
      });
      return res?.data;
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.clear();
      }
      return false;
    }
  },
  acLoanSeo({ commit }, params) {
    commit("setLoanSeo", params);
  },
  acClearLoanSeo({ commit }) {
    commit("setLoanSeo", { type: null, deposit: null });
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
